import { useEffect, useRef } from 'react';

const isScrollable = (element) => {
  if (!element || typeof window === 'undefined') return false;
  const { overflowY } = window.getComputedStyle(element);
  return (overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight;
};

export const useScrollToTopOnMount = () => {
  const ref = useRef(null);

  useEffect(() => {
    try {
      let node = ref.current;
      while (node && !isScrollable(node)) {
        node = node.parentElement;
      }
      if (node) {
        node.scrollTop = 0;
      }
    } catch (error) {
      // intentionally ignored
    }
  }, []);

  return ref;
};
